module.exports = __webpack_public_path__ + "static/media/instrotec.81179c44.png";